import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../atomicComponents/Button/Button';
import defaultStyles from './BackButton.module.css';
import jlrStyles from './BackButtonJlr.module.css';
import { ArrowBackIcon } from '../../icons';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';

const BackButton = ({ materialGroup, action, handleClick, basePath }) => {
  const [styles, setStyles] = useState(defaultStyles);
  const [plant] = usePlantAndLinesStore().plantState;
  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <Button className={styles.backButton} onClick={handleClick}>
      <ArrowBackIcon className={styles.arrowBackIcon} />
      <span className={styles.materialGroup}>{materialGroup}</span>
      {!materialGroup && basePath && (
        <span className={styles.materialGroup}>{basePath}</span>
      )}
      {basePath && <span className={styles.action}>/</span>}
      <span className={styles.action} data-testid={action}>
        {action}
      </span>
    </Button>
  );
};

BackButton.propTypes = {
  materialGroup: PropTypes.string,
  action: PropTypes.string,
  handleClick: PropTypes.func,
  userMaterialGroups: PropTypes.arrayOf(
    PropTypes.shape({
      materialGroup: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  basePath: PropTypes.string,
};

export { BackButton as BaseBackButton };

export default BackButton;
